import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private apiUrl = `${environment.apiUrl}/dispo/contacts`;

  constructor(private http: HttpClient) { }

  /**
   * Alle Kontakte laden
   */
  getAllContacts(): Observable<any> {
    return this.http.get(this.apiUrl);
  }

  /**
   * Kontakte für ein bestimmtes Modul laden
   */
  getModuleContacts(moduleId: string, moduleItemId: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/${moduleId}/${moduleItemId}`);
  }

  /**
   * Einzelnen Kontakt laden
   */
  getContact(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`);
  }

  /**
   * Neuen Kontakt erstellen
   */
  createContact(contactData: any): Observable<any> {
    return this.http.post(this.apiUrl, { data: contactData });
  }

  /**
   * Kontakt aktualisieren
   */
  updateContact(id: number, contactData: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, { data: contactData });
  }

  /**
   * Kontakt löschen
   */
  deleteContact(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  /**
   * Kontakt für ein bestimmtes Modul erstellen
   */
  createContactByModule(moduleId: string, moduleItemId: string, contactData: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/store_contact_by_module/${moduleId}/${moduleItemId}`, { data: contactData });
  }
}
